const ObjectType = {
    MESH: 'mesh',
    COMPOSITION3D: 'composition3d',
    ANIMATION3D: 'animation3d'
};

export const ObjectAnimationType = {
    BUTTERFLY_WINGS: 'butterflyWings',
    DRAGONFLY_WINGS: 'dragonflyWings',
    WIND_OSCILLATE: 'windOscillate'
};

export default ObjectType;
